import { useAddresses } from '@entities/schedules';
import cn from 'classnames';
import format from 'date-fns/format';
import React, { memo } from 'react';
import { calcHeight, calcTop, isYMoreThanNeed } from '@features/shedules/cursor-session/helpers.ts';
import { Camera, Close } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks/index.ts';
import { AddressIcon } from '@shared/ui/smart-icons';
import { useMousePosition } from './model';
import * as st from './styles.module.scss';

interface Props {
  sessionRef: React.MutableRefObject<any>;
  children?: React.ReactNode;
}

export const CursorSession = memo(({ sessionRef }: Props) => {
  useMousePosition();

  const windowWidth = useWindowWidth();

  const { activeAddressId } = useAddresses();
  // console.log('x:', sessionRef.current.x);
  // console.log('y:', sessionRef.current.y);
  const icons: { [x: string]: JSX.Element } = {
    ON: <Camera />,
    OF: <AddressIcon id={activeAddressId ?? undefined} />,
  };
  const height = calcHeight(sessionRef, windowWidth);
  const isPartEnd = sessionRef.current.part === 'end';
  const isTouchedYBoundary = isYMoreThanNeed(sessionRef, windowWidth);

  const isShowInfo = !isPartEnd && height >= 34;
  return (
    <div
      style={{
        left: sessionRef.current.x,
        top: calcTop(sessionRef, windowWidth),
        display: sessionRef.current.isVisible ? 'block' : 'none',
        height: height,
        width: sessionRef.current.width,
      }}
      className={cn(
        st.session,
        st[sessionRef.current.part],
        st[sessionRef.current.action],
        isTouchedYBoundary && st.dashedTopBorder
      )}
    >
      <div className={st.session__wrapper}>
        {isShowInfo && (
          <div className={st.session__time}>{format(sessionRef.current.start, 'HH:mm')}</div>
        )}
        <div className={st.session__icon}>
          {sessionRef.current.action === 'remove' && isShowInfo ? (
            <React.Fragment>
              <Close />
            </React.Fragment>
          ) : (
            isShowInfo && <React.Fragment>{icons[sessionRef.current.mode]}</React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
});
